import { render, staticRenderFns } from "./WholesaleAddIntroducerPage.vue?vue&type=template&id=57d97672&scoped=true&"
import script from "./WholesaleAddIntroducerPage.vue?vue&type=script&lang=js&"
export * from "./WholesaleAddIntroducerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d97672",
  null
  
)

export default component.exports